export default ({ state, commit, dispatch, rootState }, file) => {
    let authId = rootState.user.user.id
    const providers = rootState.provider.providers.reduce((acc, provider) => {
        acc.push(provider.provider)
        return acc
    }, [])
    const currProvider = rootState.provider.id
    commit('uploadFileInit')
    return dispatch('get', {
        url: "/user/" + authId + "/upload",
        query: {
            type: file.name.split(".").pop(),
            mime: file.type,
            action: "import"
        }
    }, {
        root: true
    }).then((response) => {
        let formData = new FormData()
        formData.append('key', response.key)
        formData.append('Policy', response.policy)
        formData.append('X-Amz-Signature', response.signature)
        formData.append('X-Amz-Credential', response.credential)
        formData.append('X-Amz-Algorithm', response.algorithm)
        formData.append('X-Amz-Date', response.date)
        formData.append('acl', response.acl)
        formData.append('X-Amz-Security-Token', response.security)
        formData.append('Content-Type', file.type)
        formData.append('file', file)
        return dispatch("post", {
            url: response.url,
            data: formData,
            withBaseUrl: false
        }, {
            root: true
        }).then((res) => {
            const key = response.key
            return dispatch('post', {
                url: "/provider/" + currProvider + "/import",
                data: {
                    upload: response.url + '/' + key,
                    provider: providers
                }
            }, {
                root: true
            }).then((result) => {
                commit('setUploadKey', response.url + '/' + key)
                commit('uploadFileSuccess', result)
            }).catch(err => {
                console.log(err)
                commit("uploadFileError", err)
            })
        }).catch((err) => {
            console.log(err)
            commit("uploadFileError", err)
        })
    }).catch((err) => {
        console.log(err)
        commit("uploadFileError", err)
    })
}